export interface Defer<T, E> extends Promise<T> {
  resolve: (data: T) => void;
  reject: (err: E) => void;
}

// @ts-ignore
Promise.allSettled =
  Promise.allSettled ||
  // @ts-ignore
  function(promises) {
    // @ts-ignore
    let mappedPromises = promises.map((p) => {
      return (
        p
          // @ts-ignore
          .then((value) => {
            return {
              status: 'fulfilled',
              value,
            };
          })
          // @ts-ignore
          .catch((reason) => {
            return {
              status: 'rejected',
              reason,
            };
          })
      );
    });
    return Promise.all(mappedPromises);
  };

const p: Record<string, undefined | Defer<any, any>> = {};

export function defer<T = any, E = any>(name: string): Defer<T, E> {
  if (p[name]) return p[name] as Defer<T, E>;

  let res, rej;

  const deferred = new Promise<T>((resolve, reject) => {
    res = resolve;
    rej = reject;
  }) as Defer<T, E>;

  // @ts-ignore
  deferred.resolve = res;
  // @ts-ignore
  deferred.reject = rej;

  p[name] = deferred;

  return deferred;
}

defer.recycle = function <T = any, E = any>(name: string): Defer<T, E> {
  const result = defer<T, E>(name);
  result.then(() => {
    delete p[name];
  });
  return result;
};

defer.all = function(...names: string[]): Promise<any> {
  const deffered = names.map((name) => defer(name));
  return Promise.allSettled(deffered);
};
